module.exports = __webpack_public_path__ + "img/photoshop-colors.ca320387.png";